import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PublicPage } from '../../../components/public-page/public-page';

export function RegistrationConfirmComplete() {
  return (
    <PublicPage
      title={
        <FormattedMessage
          id="KS_P_REGISTRATION_CONFIRM_COMPLETE_TITLE"
          defaultMessage="Registrace byla potvrzena"
        />
      }
    >
      <FormattedMessage
        id="KS_P_REGISTRATION_CONFIRM_COMPLETE_SUBTITLE"
        defaultMessage="Pokračujte přihlášením do aplikace."
      />
    </PublicPage>
  );
}
